/**
 * Copy for the Idle Cafe page, drawn from the game's own tutorial modals
 * (mossandmoon `src/Constants/tutorial.ts`) so the site and the game describe
 * the game the same way.
 *
 * The app is Idle Café; the café you run inside it is Moss & Moon.
 */
export const IDLE_CAFE_SUBTITLE = 'A cosy corner of Magic Town';

export const IDLE_CAFE_HEADLINE = 'Brew. Hire. Decorate. Repeat.';

export const IDLE_CAFE_TAGLINE =
  'Moss & Moon is the little café you have just opened in Magic Town. Turn it into a cosy, mystical home, and get it ready to welcome the folk who live here.';

export type CafeFeature = {
  title: string;
  body: string;
};

export const IDLE_CAFE_FEATURES: CafeFeature[] = [
  {
    title: 'Open the doors',
    body: 'Add new items to your menu, then tap one to make it and earn coins from your customers. Upgrade your equipment to earn more from every cup.',
  },
  {
    title: 'Build your team',
    body: 'Hire staff to help with orders, so you can get on with making Moss & Moon the café you have always imagined.',
  },
  {
    title: 'Make it yours',
    body: 'Unlock decorations to bring the café to life as you build your place in Magic Town — and every upgrade gives your earnings a boost.',
  },
  {
    title: 'Close out the day',
    body: 'Turn a day of earnings into Moonlight. Banked Moonlight buys permanent bonuses, helping your café grow faster every day.',
  },
];
